<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper" ref="formContainer">
      <div class="content container-fluid">
        <!-- Page Header -->
        <attendance-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          :hasCreatePermission="hasCreatePermission"
        />
        <!-- /Page Header -->
        <!--
		<div class="row">
			<div class="col-md-6 col-sm-6 col-lg-6 col-xl-2">
				<div class="stats-info">
					<h6>Full Day</h6>
					<h5>FD</h5>
				</div>
			</div>
			<div class="col-md-6 col-sm-6 col-lg-6 col-xl-2">
				<div class="stats-info">
					<h6>Half Day</h6>
					<h5>HD</h5>
				</div>
			</div>
			<div class="col-md-6 col-sm-6 col-lg-6 col-xl-2">
				<div class="stats-info">
					<h6>Absent</h6>
					<h5>A</h5>
				</div>
			</div>
			<div class="col-md-6 col-sm-6 col-lg-6 col-xl-2">
				<div class="stats-info">
					<h6>Holiday</h6>
					<h5>HL</h5>
				</div>
			</div>
			<div class="col-md-6 col-sm-6 col-lg-6 col-xl-2" v-for="singleleavetye in leavetype_list" :key="singleleavetye.id">
				<div class="stats-info">
					<h5>{{singleleavetye.type}}</h5>
					<h5>{{singleleavetye.short_code}}</h5>
				</div>
			</div>
			
		</div> -->
        <!--
		<div class="row">
			<div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
				<p>Half Day (HD), Half Day (HD)</p>
			</div>
		</div>	-->
        <div class="table-responsive mb-2">
          <table class="table table-striped custom-table table-nowrap mb-0">
            <tr>
              <td
                v-for="singleleavetye in leavetype_list"
                :key="singleleavetye.id"
              >
                {{ singleleavetye.short_code }}
              </td>
              <td>FD</td>
              <td>HD</td>
              <td>NS</td>
              <td>VL</td>
            </tr>
            <tr>
              <td
                v-for="singleleavetye in leavetype_list"
                :key="singleleavetye.id"
              >
                {{ singleleavetye.type }}
              </td>
              <td>Full Day</td>
              <td>Half Day</td>
              <td>Not Scheduled</td>
              <td>Holiday</td>
            </tr>
          </table>
        </div>
        <!-- Search Filter -->
        <!-- <attendance-filter></attendance-filter> -->
        <!-- /Search Filter -->
        <Form @submit="onSearch" class="mt-3">
          <div class="row filter-row">
            <div class="col-sm-6 col-md-2">
              <div class="input-block mb-3 form-focus focused">
                <vue-select
                  :options="employee_list"
                  id="projectreportname"
                  v-model="searchform.employeename"
                  placeholder="-"
                />
                <label class="focus-label">Employee Name</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="input-block mb-3 form-focus select-focus">
                <vue-select
                  :options="Month"
                  id="month"
                  placeholder="-"
                  v-model="searchform.month"
                />
                <label class="focus-label">Select Month</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="input-block mb-3 form-focus select-focus">
                <vue-select
                  :options="Year"
                  id="year"
                  placeholder="-"
                  v-model="searchform.year"
                />
                <label class="focus-label">Select Year</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <button class="btn w-100 btn-success submit-btn mb-3">
                Search
              </button>
            </div>
            <div class="col-sm-6 col-md-2">
              <button
                @click.prevent="clearFilter"
                class="btn w-100 btn-danger submit-btn"
              >
                Clear
              </button>
            </div>
          </div>
        </Form>

        <div class="row">
          <div class="col-lg-12">
            <div class="table-responsive">
              <table
                class="table table-striped custom-table table-nowrap mb-0"
                v-if="false"
              >
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th v-for="n in totaldays" :key="n">{{ n }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in data" :key="item.id">
                    <td>
                      <h2 class="table-avatar">
                        <router-link :to="{ path: '/profile/' + item.id }"
                          >{{ item.first_name }}
                          {{ item.last_name }}</router-link
                        >
                      </h2>
                    </td>
                    <td
                      v-for="inneritem in item.monthlyreport.dates"
                      :key="inneritem.id"
                    >
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        @click="AttendanceDetail(inneritem)"
                        v-if="inneritem.total_hours >= 5"
                        style="color: green"
                        title="Full Day"
                        >FD<!--<i class="fa-solid fa-check text-success"></i
						>--></a
                      >
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        @click="AttendanceDetail(inneritem)"
                        style="color: green"
                        title="Half Day"
                        v-else-if="
                          inneritem.total_hours > 0 && inneritem.total_hours < 5
                        "
                      >
                        HD
                        <!-- <div class="half-day">
                        <span class="first-off"
                          ><a
                            href="javascript:void(0);"
                            data-bs-toggle="modal"
                            data-bs-target="#attendance_info"
                            ><i class="fa-solid fa-check text-success"></i></a
                        ></span>
                        <span class="first-off"><i class="fa fa-close text-danger"></i></span>
                      </div>
					  -->
                      </a>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info3"
                        @click="AttendanceDetail(inneritem)"
                        v-else-if="inneritem.is_holiday == 1"
                        style="color: green"
                        title="Holiday"
                        >VL<!--<i class="fa-solid fa-check text-success"></i 
						>-->
                      </a>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info2"
                        @click="AttendanceDetail(inneritem)"
                        v-else-if="inneritem.is_leave == 1"
                        style="color: green"
                        v-bind:title="inneritem.leave_type"
                        >{{ getFirstLetters(inneritem.leave_type)
                        }}<!--<i class="fa-solid fa-check text-success"></i
						>-->
                      </a>
                      <a
                        href="javascript:void(0);"
                        v-else-if="inneritem.isfuture == 1"
                      ></a>
                      <template v-else-if="inneritem.total_hours <= 0">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#add_attendance"
                          v-if="hasCreatePermission"
                          style="color: red"
                          title="Not Scheduled"
                          >NS<!--<i class="fa fa-close text-danger"></i
                          >--></a
                        >
                        <span v-else style="color: red" title="Not Scheduled"
                          >NS</span
                        >
                      </template>
                      <!--
						<a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i class="fa-solid fa-check text-success"></i
                      ></a>
					  
					 
					  
					  -->
                    </td>
                  </tr>
                  <!--<tr v-for="item in Attendance" :key="item.id">
                    <td>
                      <h2 class="table-avatar">
                        <router-link class="avatar avatar-xs" to="profile"
                          ><img
                            :src="require(`@/assets/img/profiles/${item.Image}`)"
                            alt="User Image"
                        /></router-link>
                        <router-link to="profile">{{ item.Employee }}</router-link>
                      </h2>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class1"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class2"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class3"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class4"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class5"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class6"></i
                      ></a>
                    </td>
                    <td>
                      <div class="half-day">
                        <span class="first-off"
                          ><a
                            href="javascript:void(0);"
                            data-bs-toggle="modal"
                            data-bs-target="#attendance_info"
                            ><i :class="item.Class7"></i></a
                        ></span>
                        <span class="first-off"><i :class="item.Classa"></i></span>
                      </div>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class9"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i class="fa-solid fa-check text-success"></i
                      ></a>
                    </td>
                    <td><i :class="item.Class10"></i></td>
                    <td><i :class="item.Class11"></i></td>
                    <td><i :class="item.Class12"></i></td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class13"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class14"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class15"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class16"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class17"></i
                      ></a>
                    </td>
                    <td><i class="fa fa-close text-danger"></i></td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class18"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class19"></i
                      ></a>
                    </td>
                    <td>
                      <div class="half-day">
                        <span class="first-off"><i :class="item.Class20"></i></span>
                        <span class="first-off"
                          ><a
                            href="javascript:void(0);"
                            data-bs-toggle="modal"
                            data-bs-target="#attendance_info"
                            ><i :class="item.Classb"></i></a
                        ></span>
                      </div>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class22"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class22"></i
                      ></a>
                    </td>
                    <td><i :class="item.Class23"></i></td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class23"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class24"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class25"></i
                      ></a>
                    </td>
                    <td><i :class="item.Class26"></i></td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class27"></i
                      ></a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        ><i :class="item.Class28"></i
                      ></a>
                    </td>
                  </tr> -->
                </tbody>
              </table>

              <div class="showentries mb-3">
                <label
                  >Show
                  <select v-model="pagination.pageSize" @change="updatePerPage">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  entries</label
                >
              </div>

              <a-table
                :columns="columns"
                :data-source="data"
                :pagination="{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: pagination.total,
                  showTotal: (total) => `Total ${total} records`,
                  onChange: handleTableChange,
                }"
                bordered
                row-key="id"
              >
                <template #bodyCell="{ column, record }">
                  <!-- Employee Name -->
                  <template v-if="column.dataIndex === 'employee'">
                    <h2 class="table-avatar">
                      <router-link :to="{ path: '/profile/' + record.id }">
                        {{ record.first_name }} {{ record.last_name }}
                      </router-link>
                    </h2>
                  </template>

                  <!-- Attendance Days -->
                  <template v-else-if="column.isDayColumn">
                    <template
                      v-for="inneritem in record.monthlyreport.dates"
                      :key="inneritem.id"
                    >
                      <template
                        v-if="
                          parseInt(inneritem.date.split('-')[0]) === column.date
                        "
                      >
                        <a
                          v-if="inneritem.total_hours >= 5"
                          href="javascript:void(0);"
                          style="color: green"
                          title="Full Day"
                          data-bs-toggle="modal"
                          data-bs-target="#attendance_info"
                          @click="AttendanceDetail(inneritem)"
                          >FD</a
                        >

                        <a
                          v-else-if="
                            inneritem.total_hours > 0 &&
                            inneritem.total_hours < 5
                          "
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#attendance_info"
                          style="color: green"
                          title="Half Day"
                          @click="AttendanceDetail(inneritem)"
                          >HD</a
                        >

                        <a
                          v-else-if="inneritem.is_holiday == 1"
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#attendance_info3"
                          style="color: green"
                          title="Holiday"
                          @click="AttendanceDetail(inneritem)"
                          >VL</a
                        >

                        <a
                          v-else-if="inneritem.is_leave == 1"
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#attendance_info2"
                          style="color: green"
                          :title="inneritem.leave_type"
                          @click="AttendanceDetail(inneritem)"
                          >{{ getFirstLetters(inneritem.leave_type) }}</a
                        >

                        <a
                          v-else-if="inneritem.isfuture == 1"
                          href="javascript:void(0);"
                        ></a>

                        <template v-else-if="inneritem.total_hours <= 0">
                          <a
                            v-if="hasCreatePermission"
                            href="javascript:void(0);"
                            data-bs-toggle="modal"
                            data-bs-target="#add_attendance"
                            style="color: red"
                            title="Not Scheduled"
                            @click="AttendanceDetail(inneritem)"
                            >NS</a
                          >
                          <span v-else style="color: red" title="Not Scheduled"
                            >NS</span
                          >
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->

      <attendance-model
        :selecteddatedata="selecteddatedata"
        @edit-attendance="openEditModal"
      ></attendance-model>
      <add-attendance-model
        :form="create_form"
        :employeelist="employee_list"
        @create-attendance="createAttendance"
        :editForm="edit_form"
        @update-attendance="updateAttendance"
        :backendErrors="backend_error"
		:selectedtimesheet="selectedtimesheet"
		:formnew="formnew"
		:addform="addform"
		:employee_list2="employee_list2"
		:designation_list2="designation_list2"
		@updateattendancenew="updateattendancenew"
		@addattendancenew="addattendancenew"
        ref="attendanceModal"
      ></add-attendance-model>
    </div>
    <!-- Page Wrapper -->
  </div>
</template>

<script>
import Attendance from "@/assets/json/attendance.json";

import axios from "axios";
import { notification } from "ant-design-vue";

import { Form, Field } from "vee-validate";

import moment from "moment";
import { ref } from "vue";
const currentDate = ref(new Date(moment()));


export default {
  components: {
    Form,
    Field,
  },
  data() {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= 2020; year--) {
      years.push(year.toString());
    }

    return {
	  addform: {
        user_id: "",
        designation_id: "",
        punch_in_time: "",
        punch_out_time: "",
      },
	  employee_list2: [],
	  designation_list2: [],
	  startdate: currentDate,
	  formnew: {
        punch_in_time: "",
        punch_out_time: "",
      },
	  selectedtimesheet: [],
      Attendance: Attendance,
      title: "Attendance",
      path: "Dashboard",
      text: "Attendance",
      text1: "Add Attendance",
      data: [],
      create_form: {
        employee_id: "",
        date: "",
        punch_in_time: "",
        punch_out_time: "",
        punch_in_date: null,
        punch_out_date: null,
        is_break: false,
        reason: "",
        punch_from: "",
        break_start_time: "",
        break_end_time: "",
        break_start_date: null,
        break_end_date: null,
      },
      backend_error: {},
      edit_form: {},
      totaldays: 30,
      select2: null,
      Month: [
        "-",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      Year: ["-", ...years],
      employeeID: "",
      isFocused: false,
      searchform: { employeename: "", month: "", year: "" },
      selecteddatedata: [],
      employee_list: [],
      leavetype_list: {},
      hasReadPermission: null,
      hasCreatePermission: null,
      columns: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
	addattendancenew(addform,addstartdate){
		
	    	var token = window.localStorage.getItem("token");

		  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
		  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
		  axios.defaults.headers.common["Content-Type"] = "multipart/form-data";

		  let loader = this.$loading.show({
			// Optional parameters
			container: this.$refs.formContainer,
			canCancel: false,
		  });

		  var postform = new FormData();

		  postform.append("user_id", addform.user_id);
		  postform.append(
			"timesheet_date",
			moment(addstartdate).format("YYYY-MM-DD")
		  );
		  
		  if (addform.punch_in_time != "") {
			/*const datePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
				const timePart = this.addform.punch_in_time; 
				const fullDateTime = moment(`${datePart} ${timePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append("clocked_in", fullDateTime);*/

			postform.append("clocked_in", addform.punch_in_time);
		  } else {
			postform.append("clocked_in", "");
		  }
		  

		  if (addform.punch_out_time != "") {
			/*const datePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
				const timePart2 = this.addform.punch_out_time; 
				const fullDateTime2 = moment(`${datePart} ${timePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append("clocked_out", fullDateTime2);*/

			postform.append("clocked_out", addform.punch_out_time);
		  } else {
			postform.append("clocked_out", "");
		  }
		  
		  
		  if (addform.dailyreport?.list_breaks?.breaks?.length) {
			addform.dailyreport.list_breaks.breaks.forEach((brk, index) => {
			  //console.log(brk);

			  /*var bdatePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
					var btimePart = brk.punch_out_time_str; 
					var bfullDateTime = moment(`${bdatePart} ${btimePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
					
					postform.append(`breaks[${index}][clocked_out_datetime]`, bfullDateTime);*/

			  postform.append(
				`breaks[${index}][clocked_out_datetime]`,
				brk.punch_out_time_str
			  );

			  /*var bdatePart2 = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
					var btimePart2 = brk.punch_in_time_str; 
					var bfullDateTime2 = moment(`${bdatePart2} ${btimePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
					
					postform.append(`breaks[${index}][clocked_in_datetime]`, bfullDateTime2);*/

			  postform.append(
				`breaks[${index}][clocked_in_datetime]`,
				brk.punch_in_time_str
			  );
			});
		  } else {
			postform.append("breaks", []);
		  }
		  
		  
		  if (addform.dailyreport?.both_list_breaks?.unpaid_breaks?.length) {
        addform.dailyreport.both_list_breaks.unpaid_breaks.forEach(
          (brk, index) => {
            //console.log(brk);

            /*var bdatePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart = brk.punch_out_time_str; 
				var bfullDateTime = moment(`${bdatePart} ${btimePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_out_datetime]`, bfullDateTime);*/

            postform.append(
              `unpaid_breaks[${index}][clocked_out_datetime]`,
              brk.punch_out_time_str
            );

            /*var bdatePart2 = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart2 = brk.punch_in_time_str; 
				var bfullDateTime2 = moment(`${bdatePart2} ${btimePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_in_datetime]`, bfullDateTime2);*/

            postform.append(
              `unpaid_breaks[${index}][clocked_in_datetime]`,
              brk.punch_in_time_str
            );
          }
        );
      } else {
        postform.append("unpaid_breaks", []);
      }
	  
	  postform.append("designation_id", addform.designation_id);
	  
	  
	  
	  axios
        .post("/updatedailyreview", postform)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          
          this.$refs.attendanceModal.closeDialog();
		  this.onSearch();
		  
		  this.addform = { user_id: "", punch_in_time: "", punch_out_time: "" };
          
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || null;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
		
		  

	},
    updateattendancenew(selectedtimesheet,form){
		
	  var getdate = this.parseDisplayDate(selectedtimesheet.dailyreport.date);
		
	  var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      axios.defaults.headers.common["Content-Type"] = "multipart/form-data";

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var postform = new FormData();
      postform.append("user_id", selectedtimesheet.id);
      postform.append("timesheet_date",getdate);

      if (form.punch_in_time != "") {
        /*const datePart = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
			const timePart = this.form.punch_in_time; 
			const fullDateTime = moment(`${datePart} ${timePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
			
			postform.append("clocked_in", fullDateTime);*/

        postform.append("clocked_in", form.punch_in_time);
      } else {
        postform.append("clocked_in", "");
      }

      if (form.punch_out_time != "") {
        /*const datePart = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
			const timePart2 = this.form.punch_out_time; 
			const fullDateTime2 = moment(`${datePart} ${timePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
			
			postform.append("clocked_out", fullDateTime2);*/

        postform.append("clocked_out", form.punch_out_time);
      } else {
        postform.append("clocked_out", "");
      }

      console.log(selectedtimesheet.dailyreport?.list_breaks.breaks);

      if (selectedtimesheet.dailyreport?.list_breaks?.breaks?.length) {
        selectedtimesheet.dailyreport.list_breaks.breaks.forEach(
          (brk, index) => {
            //console.log(brk);

            /*var bdatePart = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart = brk.punch_out_time_str; 
				var bfullDateTime = moment(`${bdatePart} ${btimePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_out_datetime]`, bfullDateTime);*/

            postform.append(
              `breaks[${index}][clocked_out_datetime]`,
              brk.punch_out_time_str
            );

            /*var bdatePart2 = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart2 = brk.punch_in_time_str; 
				var bfullDateTime2 = moment(`${bdatePart2} ${btimePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_in_datetime]`, bfullDateTime2);*/

            postform.append(
              `breaks[${index}][clocked_in_datetime]`,
              brk.punch_in_time_str
            );
          }
        );
      } else {
        postform.append("breaks", []);
      }

      if (selectedtimesheet.dailyreport?.both_list_breaks?.unpaid_breaks?.length) {
	  
			selectedtimesheet.dailyreport.both_list_breaks.unpaid_breaks.forEach(
          (brk, index) => {
            //console.log(brk);

            /*var bdatePart = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart = brk.punch_out_time_str; 
				var bfullDateTime = moment(`${bdatePart} ${btimePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_out_datetime]`, bfullDateTime);*/

            postform.append(
              `unpaid_breaks[${index}][clocked_out_datetime]`,
              brk.punch_out_time_str
            );

            /*var bdatePart2 = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart2 = brk.punch_in_time_str; 
				var bfullDateTime2 = moment(`${bdatePart2} ${btimePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_in_datetime]`, bfullDateTime2);*/

            postform.append(
              `unpaid_breaks[${index}][clocked_in_datetime]`,
              brk.punch_in_time_str
            );
          }
        );
      } else {
        postform.append("unpaid_breaks", []);
      }

      axios
        .post("/updatedailyreview", postform)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });
		  
			this.$refs.attendanceModal.closeDialog();
			this.onSearch();
         
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || null;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
		
	},
    clearFilter() {
      this.searchform = { employeename: "", month: "", year: "" };
      this.onSearch();
    },
	parseDisplayDate(dateStr) {
      
	   var [day, monthStr, year] = dateStr.split(" ");

	  var months = {
		Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
		Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
	  };

	  const d = new Date(year, months[monthStr], day);

	  return (
		d.getFullYear() +
		"-" +
		String(d.getMonth() + 1).padStart(2, "0") +
		"-" +
		String(d.getDate()).padStart(2, "0")
	  );
  
    },
    openEditModal(data) {
	
		console.log('av');
		console.log(data);
		
		//var getdate = new Date(data.date).toISOString().split("T")[0];
		var getdate = this.parseDisplayDate(data.date);
		
	    var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios.get("dailyreview", {
				params: {
				  selecteddate: getdate,
				  s_employee_id: data.punchingdetails[0]?.user_id || "",
				},
	    }).then((response) => {
		
		  //this.selectedtimesheet = response.data.data;
		  
		  var data = response.data.data;
		  var record = Array.isArray(data) && data.length > 0 ? data[0] : {};
		  
		  
		  this.selectedtimesheet = JSON.parse(JSON.stringify(record));

		  if (this.selectedtimesheet.dailyreport?.designationdetails) {
			this.selectedDesignation =
			  this.selectedtimesheet.dailyreport?.designationdetails.name || "";
		  } else {
			this.selectedDesignation =
			  this.selectedtimesheet.designation?.name || "";
		  }

		  if (
			record?.dailyreport?.list_breaks?.breaks &&
			Array.isArray(record.dailyreport.list_breaks.breaks)
		  ) {
			this.selectedtimesheet.dailyreport.list_breaks.breaks.forEach((b) => {
			  //b.punch_in_time_str = this.extractTime(b.punch_in_employee_attendances_details_time);
			  b.punch_in_time_str = b.punch_in_employee_attendances_details_time;
			  //b.punch_out_time_str = this.extractTime(b.punch_out_employee_attendances_details_time);
			  b.punch_out_time_str = b.punch_out_employee_attendances_details_time;
			});
		  }

		  if (
			record?.dailyreport?.both_list_breaks?.unpaid_breaks &&
			Array.isArray(record.dailyreport.both_list_breaks.unpaid_breaks)
		  ) {
			this.selectedtimesheet.dailyreport.both_list_breaks.unpaid_breaks.forEach(
			  (b) => {
				//b.punch_in_time_str = this.extractTime(b.punch_in_employee_attendances_details_time);
				b.punch_in_time_str = b.punch_in_employee_attendances_details_time;
				//b.punch_out_time_str = this.extractTime(b.punch_out_employee_attendances_details_time);
				b.punch_out_time_str =
				  b.punch_out_employee_attendances_details_time;
			  }
			);
		  }

		  this.formnew = { punch_in_time: "", punch_out_time: "" };

		  console.log(this.selectedtimesheet);

		  if (record.dailyreport && record.dailyreport.firstpunch != "") {
			//this.form.punch_in_time = this.extractTime(record.dailyreport.firstpunch);
			this.formnew.punch_in_time = record.dailyreport.firstpunch;
		  }

		  if (record.dailyreport && record.dailyreport.lastpunch != "") {
			//this.form.punch_out_time = this.extractTime(record.dailyreport.lastpunch);
			this.formnew.punch_out_time = record.dailyreport.lastpunch;
		  }
	  
		  
		  loader.hide();
				  

        }).catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;
            if (response.data && response.data.error) {
              this.backend_error = response.data.error;
            }
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
		
		
		
      const breakDetails = this.processPunchingDetails(data.punchingdetails);
      const punchIn = this.parseTimeString(data.firstpunch);
      const punchOut = this.checkFinalPunchOut(data.punchingdetails);

      this.edit_form = {
        employee_id: data.punchingdetails[0]?.user_id || "",
        employee_attendances_id:
          data.punchingdetails[0]?.employee_attendance_id || null,
        date: new Date(data.date),
        // punch_from: data.punch_from || "1", // Default to Office
        punch_in_time: punchIn,
        punch_out_time: punchOut.time,
        punch_in_date: new Date(data.date),
        punch_out_date: punchOut.date,
        is_break: breakDetails.is_break,
        break_details: breakDetails.breaks,
      };
    },
    handleTableChange(page, pageSize) {
      var params = {
        params: {
          employeename: this.searchform.employeename,
          month: this.searchform.month,
          year: this.searchform.year,
          page: page,
          per_page: pageSize,
        },
      };
      this.loadCommonData(params);
    },
    updatePerPage() {
      var params = {
        params: { per_page: this.pagination.pageSize, ...this.searchform },
      };
      this.loadCommonData(params);
    },
    generateColumns() {
      this.columns = [
        {
          title: "Employee",
          dataIndex: "employee",
          key: "employee",
        },
        ...Array.from({ length: this.totaldays }, (_, i) => ({
          title: `${i + 1}`,
          dataIndex: `day${i + 1}`,
          key: `day${i + 1}`,
          isDayColumn: true,
          date: i + 1,
        })),
      ];
    },
    checkFinalPunchOut(punchingdetails) {
      if (!punchingdetails || punchingdetails.length === 0) {
        return { time: null, date: null };
      }

      const finalPunchOuts = punchingdetails.filter(
        (entry) => entry.punch_out_reason === "Final Punch Out"
      );

      const lastFinalPunchOut =
        finalPunchOuts.length > 0
          ? finalPunchOuts[finalPunchOuts.length - 1]
          : null;

      // const finalPunchOut = punchingdetails.find(
      //   (entry) => entry.punch_out_reason === "Final Punch Out"
      // );

      if (!lastFinalPunchOut) {
        return { time: null, date: null };
      }

      return {
        time: this.parseTimeString(
          lastFinalPunchOut.employee_attendances_details_time_formatted
        ),
        date: new Date(
          lastFinalPunchOut.employee_attendances_details_time_formatted
        ),
      };
    },
    parseTimeString(timeString) {
      if (!timeString) return null;

      // const timeMatch = timeString.match(/(\d{2}:\d{2}:\d{2})/);

      // if (timeMatch) {
      //   return timeMatch[1];
      // }

      const time = timeString.match(/(\d{1,2}:\d{2})(?::\d{2})?$/);

      if (time) {
        const [hours, minutes] = time[1].split(":").map(Number);
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:00`;
      }

      // const timePart = timeString.split(" ").slice(-2).join(" ");

      // const [time, period] = timePart.split(" ");
      // let [hours, minutes] = time.split(":").map(Number);

      // if (period.toLowerCase() === "pm" && hours !== 12) {
      //   hours += 12;
      // } else if (period.toLowerCase() === "am" && hours === 12) {
      //   hours = 0;
      // }
      // return `${hours.toString().padStart(2, "0")}:${minutes
      //   .toString()
      //   .padStart(2, "0")}:00`;
    },
    processPunchingDetails(punchingdetails) {
      if (!punchingdetails || punchingdetails.length <= 2) {
        return {
          is_break: false,
          breaks: [],
        };
      }

      const breaks = [];
      let currentBreak = null;
      let breakCount = 1;

      for (let i = 1; i < punchingdetails.length; i++) {
        const entry = punchingdetails[i];

        if (entry.punch_out_reason === "Final Punch Out") continue;

        if (
          entry.employee_attendances_details_type === 1 &&
          ["On Break", "On Lunch", "On Hourly Leave"].includes(
            entry.punch_out_reason
          )
        ) {
          currentBreak = {
            number: breakCount++,
            start_time_id: entry.employee_attendances_details_id,
            end_time_id: null,
            reason: entry.punch_out_reason,
            start_time: this.parseTimeString(
              entry.employee_attendances_details_time_formatted
            ),
            end_time: null,
            start_date: new Date(
              entry.employee_attendances_details_time_formatted
            ),
            end_date: null,
          };

          if (
            i + 1 < punchingdetails.length &&
            punchingdetails[i + 1].employee_attendances_details_type === 0
          ) {
            currentBreak.end_time_id =
              punchingdetails[i + 1].employee_attendances_details_id;

            currentBreak.end_time = this.parseTimeString(
              punchingdetails[i + 1].employee_attendances_details_time_formatted
            );

            currentBreak.end_date = new Date(
              punchingdetails[i + 1].employee_attendances_details_time_formatted
            );
            i++;
          }

          breaks.push(currentBreak);
          currentBreak = null;
        }
      }

      return {
        is_break: breaks.length > 0,
        breaks: breaks,
      };
    },
    getFirstLetters(getstring) {
      var words = getstring.split(" ");
      var rs = words.map((word) => word.charAt(0)).join("");

      return rs.toUpperCase();
    },
    AttendanceDetail(details) {
      this.selecteddatedata = details;
    },
    onSearch() {
      var params = {
        params: {
          employeename: this.searchform.employeename,
          month: this.searchform.month,
          year: this.searchform.year,
          // page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };

      this.loadCommonData(params);
    },
    createAttendance(formval) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .post("employeeattendance/add-attendance", formval)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.attendanceModal.closeDialog();

          this.create_form = {
            employee_id: "",
            date: "",
            punch_in_time: "",
            punch_out_time: "",
            is_break: false,
            reason: "",
            punch_from: "",
            break_start_time: "",
            break_end_time: "",
          };
          this.backend_error = null;
          this.onSearch();
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;
            if (response.data && response.data.error) {
              this.backend_error = response.data.error;
            }
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    updateAttendance(formval) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .put("employeeattendance/update-attendance", formval)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.attendanceModal.closeDialog();

          this.edit_form = {};
          this.backend_error = null;
          this.onSearch();
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;
            if (response.data && response.data.error) {
              this.backend_error = response.data.error;
            }
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadCommonData(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/employeeattendance/adminattendance", params)
        .then((response) => {
          this.totaldays = response.data.days;
          this.generateColumns();

          this.data = response.data.monthlyreport;

          this.pagination.current = response.data.pagination.current_page;
          this.pagination.pageSize = response.data.pagination.per_page;
          this.pagination.total = response.data.pagination.total;

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadAllLeaveTypes(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/leavetypes/all", params)
        .then((response) => {
          this.leavetype_list = response.data.data;
        })
        .catch((error) => {
          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadAllEmployee(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/employees/all", params)
        .then((response) => {
		
		this.employee_list2 = response.data.data;
		
          for (let i = 0; i < response?.data?.data.length; i++) {
            this.employee_list.push({
              id: response.data.data[i].id,
              text:
                response.data.data[i].first_name +
                " " +
                response.data.data[i].last_name,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          var response = error.response;

          if (
            error.response?.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
	loadDesignations(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.$refs.formContainer,
      //   canCancel: false,
      // });

      axios
        .get("/designations/all", params)
        .then((response) => {
          //	console.log(response.data.data.data);

          this.designation_list2 = response.data.data;

          // loader.hide();
        })
        .catch((error) => {
          // loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    }
  },
  mounted() {
    this.$store
      .dispatch("userPermissions", {
        module: "admin_attendance",
        action: "read",
      })
      .then((response) => {
        this.hasReadPermission = null;
        this.$nextTick(() => {
          this.hasReadPermission = response === "true";

          if (!this.hasReadPermission) {
            notification.open({
              message: "You don't have access to this page!",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            var user_role = window.localStorage.getItem("role");

            if (user_role && user_role.includes("Employee")) {
              this.$router
                .push({ name: "employee-dashboard" })
                .catch((error) => {});
            } else {
              this.$router
                .push({ name: "admin-dashboard" })
                .catch((error) => {});
            }
          }
        });
      });

    this.$store
      .dispatch("userPermissions", {
        module: "admin_attendance",
        action: "create",
      })
      .then((response) => {
        this.hasCreatePermission = null;
        this.$nextTick(() => {
          this.hasCreatePermission = response === "true";
        });
      });

    this.generateColumns();
    this.loadCommonData([]);
    this.loadAllLeaveTypes([]);
    this.loadAllEmployee([]);
    this.loadDesignations([]);
  },
};
</script>
